<ng-template #title>
    <div>
        {{ (item.translate || item.id) | translate : null : item.title }}
        <ng-container *ngIf="item.subtitle">
            <div [class.has-color]="!!item.subtitleColor"
                 [style.background-color]="item.subtitleColor">
                <strong>{{ 'userSettings.navigation.hintLabel' | translate }}</strong>
                {{item.subtitle}}
                <ng-container [ngSwitch]="item.subtitleType">
                    <ng-container *ngSwitchCase="'license'">
                        <a class="report-link"
                           href="mailto:vertrieb@up2boat.com?subject=Interesse%20an%20Modul%20{{ (item.translate || item.id) | translate : null : item.title }}"
                           target="_blank">
                            &#9993; {{ 'userSettings.navigation.contactSales' | translate }}
                        </a>
                    </ng-container>
                    <ng-container *ngSwitchCase="'permission'">
                        {{ 'userSettings.navigation.contactAdministrator' | translate }}
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-container *ngIf="item.type === ListItemType.Item; else container">
    <div cdkDrag
         class="item-wrapper {{item.type}}"
         [cdkDragDisabled]="!itemDraggable"
         [id]="item.id">
        <div class="item-title"
             fxLayoutAlign="space-between center">
            <div fxLayoutAlign="start center">
                <i class="material-icons drag-indicator" cdkDragHandle *ngIf="itemDraggable">
                    drag_indicator
                </i>
                <ng-container *ngTemplateOutlet="title"></ng-container>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #container>
    <div cdkDrag
         cdkDropList
         dragAndDropManager
         class="item-wrapper {{item.type}}"
         [id]="item.id"
         [cdkDragDisabled]="!itemDraggable"
         [cdkDropListData]="item.children"
         (cdkDropListDropped)="onDragDrop$.next($event)">
        <div class="item-title"
             fxLayoutAlign="space-between center">

            <div fxLayoutAlign="start center">
                <i class="material-icons drag-indicator" cdkDragHandle *ngIf="itemDraggable">
                    drag_indicator
                </i>
                <ng-container *ngIf="itemTitlesEditable; else label">
                    <input class="item-title-input" matInput [(ngModel)]="item.title"
                           [ngModelOptions]="{standalone: true}"
                           (click)="$event.stopPropagation()">
                </ng-container>

                <ng-template #label>
                    <ng-container *ngTemplateOutlet="title"></ng-container>
                </ng-template>
            </div>

            <div fxLayoutAlign="space-between center">
                <ng-container [ngSwitch]="item.type">
                    <ng-container *ngSwitchCase="ListItemType.Group">
                        <strong><small>{{ 'userSettings.navigation.typeGroup' | translate }}</small></strong>
                    </ng-container>
                    <ng-container *ngSwitchCase="ListItemType.Collapsable">
                        <strong><small>{{ 'userSettings.navigation.typeCollapsible' | translate }}</small></strong>
                    </ng-container>
                </ng-container>
            </div>
        </div>

        <ng-template #tmplItem let-currItem="currItem">
            <ng-container *ngFor="let subItem of currItem.children">
                <list-item [item]="subItem"
                           [itemTitlesEditable]="itemTitlesEditable"
                           [onDragDrop$]="onDragDrop$">
                </list-item>
            </ng-container>
        </ng-template>

        <ng-container [ngSwitch]="item.type">
            <ng-container *ngSwitchCase="'group'">
                <div class="item-wrapper">
                    <ng-container *ngTemplateOutlet="tmplItem,context:{item:item}"></ng-container>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'collapsable'">
                <div class="item-wrapper">
                    <div *ngIf="item.children?.length" class="item-children">
                        <ng-container *ngTemplateOutlet="tmplItem,context:{currItem:item}"></ng-container>
                    </div>
                </div>
            </ng-container>

        </ng-container>

    </div>

</ng-template>
